import React, { FC, useState } from "react"

import { generateConditionalClassName, isClientSide } from "@utils"

import AnchorLink from "@components/AnchorLink/AnchorLink"
import { Icon, ICON_TYPES } from "@helpscout/hs-marketing-shared-components"
import SearchInterface from "@components/SearchInterface/SearchInterface"

import "./SubNav.scss"

export type SubNavItemType = {
  link: string,
  slug: string,
  title: string,
}

type SubNavProps = {
  currentItemSlug: string | undefined
  hideSearch?: boolean | undefined
  isHierarchical?: boolean | undefined
  items: SubNavItemType[]
}

const SubNav: FC<SubNavProps> = ({
  currentItemSlug = undefined,
  hideSearch = undefined,
  isHierarchical = undefined,
  items,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isSearching, setIsSearching] = useState(false)

  const toggleIsOpen = e => {
    e.preventDefault()
    setIsOpen(!isOpen)
  }

  const toggleSearch = () => {
    setIsSearching(!isSearching)
  }
  const currentItem = items.find(item => currentItemSlug === item.slug)

  return (
    <>
      <nav className={generateConditionalClassName({
        SubNav: true,
        "is-searching": isSearching,
        "is-open": isOpen,
      })}>
        <div className="container">
          <div className="buttons">
            {currentItem && (
              <button
                aria-label={isOpen ? "Open mobile navigation" : "Close mobile navigation"}
                onClick={toggleIsOpen}
                className="SubNav--Toggle"
              >
                <span>{currentItem.title}</span>
                <Icon size="24px" type={ICON_TYPES["chevron-right"]} />
              </button>
            )}
            {!hideSearch && (
              <button
                aria-label="Open search interface"
                className={generateConditionalClassName({
                  "is-searching": isSearching,
                  "SubNav--SearchButton": true,
                })}
                onClick={toggleSearch}
              >
                <Icon size="24px" type={ICON_TYPES["search"]} />
              </button>
            )}
          </div>
          <ul
            className={generateConditionalClassName({
              "is-hierarchical": !!isHierarchical,
              "SubNav--List": true,
            })}>
            {items.map((item, i) => (
              <li key={item.title}>
                <AnchorLink
                  href={item.link}
                  className={`SubNav--Link ${currentItemSlug === item.slug ? "is-active" : ""}`}
                  data-title={item.title}
                >
                  <span>{item.title}</span>
                </AnchorLink>
                {
                  isHierarchical && i < items.length - 1 && (
                    <Icon
                      className="SubNav--DividerIcon"
                      size="24px"
                      type={ICON_TYPES["chevron-right"]}
                    />
                  )}
              </li>
            ))}
          </ul>
        </div>
      </nav >
      {isClientSide() && isSearching && <SearchInterface onClickClose={toggleSearch} />}
    </>
  )
}

export default SubNav
